// extracted by mini-css-extract-plugin
module.exports = {"container":"NoPromotions_container__3yAZh","message":"NoPromotions_message__2r32z"};